import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { StockCard, TinyStockCard, TinyPortfolioCard } from '../c/ChartCard';
import { T } from '../traks';
import { A } from '../routes';

import SearchField from '../c/SearchField';

function ExploreCard(props) {
	var ticker_css_classes = "ad_explore_card_width bg-white";

	if(props.ticker_css) {
		ticker_css_classes = ticker_css_classes + props.ticker_css;
	}

	return (
		<Col sm="12" md="6" xl="4" className="pb-5 mb-auto ad_troels_telefon_padding_fjern">
			<div className="d-flex flex-column ad_game_card ad_explore_card_width ad_troels_telefon_padding">
				<div className={ticker_css_classes}>
					{props.card}
				</div>
			</div>
		</Col>
	);
}

function StockExploreCard(props) {
	const card = <TinyStockCard no_ahref exchange={props.exchange} ticker={props.ticker} name={props.name}/>
	return <ExploreCard {...props} alt={props.ticker} card={card}/>
}

function PortfolioExploreCard(props) {
	const card = <TinyPortfolioCard no_ahref id={props.id} name={props.name}/>
	return <ExploreCard {...props} alt={props.ticker} card={card}/>
}

var Explore = (props) => {
	var sections = [];

	const currencies_name = <T>Currencies</T>;
	const commodities_name = <T>Commodities</T>;

	sections.push(
		<Row key="vndjcgfbiurgmj0i" className="align-items-center">
			<Col xs="12 pb-3">
				<b><T>Miscellaneous equities</T></b>
			</Col>
			<StockExploreCard ticker="OMXC25" exchange="IDX-DKK" card_img="/gfx/omxc25-350x136.svg" name="OMXC25" href="/portfolio/98"/>
			<StockExploreCard ticker="DJI" exchange="IDX-USD" card_img="/gfx/dow-jones-350x136-0.svg" name="Dow Jones" href="/portfolio/115"/>
			<StockExploreCard ticker="GSPC" exchange="IDX-USD" card_img="/gfx/sp500-350x136-0.svg" name="S&P 500" href="/portfolio/118"/>
			<StockExploreCard ticker="IXIC" exchange="IDX-USD" card_img="/gfx/nasdaq-350x136-0.svg" name="Nasdaq" href="/portfolio/117"/>
			<PortfolioExploreCard id={161} card_img="/gfx/currencies-350x136-0.svg" name={currencies_name} href="/explore-bank"/>
			<PortfolioExploreCard id={134} card_img="/gfx/commodities-350x136-0.svg" name={commodities_name} href="/explore-commodities"/>
			<StockExploreCard ticker="CARL-B" exchange="CPH" card_img="/gfx/carlsberg-350x136-0.svg" name="Carlsberg B" href="/ticker/CPH/CARL-B"/>
			<StockExploreCard ticker="BTC" exchange="CRYPTO" card_img="/gfx/bitcoin-350x136-0.svg" name="Bitcoin" href="/ticker/CRYPTO/BTC"/>
			<StockExploreCard ticker="CAT" exchange="NYSE" card_img="/gfx/caterpillar-350x136-0.svg" name="Caterpillar" href="/ticker/NYSE/CAT"/>
			<StockExploreCard ticker="KO" exchange="NYSE" card_img="/gfx/coca-cola-350x136-0.svg" name="Coca-Cola" href="/ticker/NYSE/KO"/>
			<StockExploreCard ticker="MA" exchange="NYSE" card_img="/gfx/mastercard-350x136-0.svg" name="Mastercard" href="/ticker/NYSE/MA"/>
			<StockExploreCard ticker="MAERSK-B" exchange="CPH" card_img="/gfx/maersk-350x136-1.svg" name="Maersk B" href="/ticker/CPH/MAERSK-B"/>
			<StockExploreCard ticker="IBM" exchange="NYSE" card_img="/gfx/ibm-350x136-0.svg" name="IBM" href="/ticker/NYSE/IBM"/>
			<StockExploreCard ticker="NOVO-B" exchange="CPH" card_img="/gfx/novo-nordisk-350x136-1.svg" name="Novo Nordisk B" href="/ticker/CPH/NOVO-B"/>
			<StockExploreCard ticker="PNDORA" exchange="CPH" card_img="/gfx/pandora-350x136-0.svg" name="Pandora" href="/ticker/CPH/PNDORA"/>
		</Row>

	);

	for (const section of props.home.Sections) {
		var title = section.Title;
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} md="3" className="pb-4">
					<StockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row className="py-5" key={section.Type}>
					<Col>
						<h2>{title}</h2>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	return (
		<span>
			<Container>
				<Row className="pt-4">
					<Col>
						<h1><T>Explore assets</T></h1>
						<div className="pt-4 pb-5"><T>Welcome to our explore assets section. This is where we collect things, that we believe
						is interesting. Feel free to reach out, if you have something you believe would be of interest here!</T></div>
					</Col>
					<Col>
						<div className="d-block d-md-none">
							<b><T>Search:</T></b>
						</div>
						<SearchField form_classes="justify-content-xl-end pb-2" input_classes="ad_search_explore_page ad_no_outline_focus " input_id="search_field_1"/>
						<div className="d-block pb-4 d-md-none"/>
					</Col>
				</Row>
				{sections}
			</Container>
		</span>
	);
}

Explore = Apify("/z/explore")
	.with_response_prop("home")
	.wrap(Explore, ApifyFullScreenLoadingComponent);

export { Explore, PortfolioExploreCard, StockExploreCard };



// WEBPACK FOOTER //
// ./src/p/Explore.js